var map = {
	"./CE/Concrete Technology.pdf": 93,
	"./CE/Fluid Mechanics-I.pdf": 94,
	"./CE/Geotechnical Engineering-I.pdf": 95,
	"./CE/Strength Of Materials.pdf": 96,
	"./CSE/Computer Network & Comm.pdf": 97,
	"./CSE/Computer Org & Arch.pdf": 98,
	"./CSE/Data Structures using C.pdf": 99,
	"./CSE/Database Management System.pdf": 100,
	"./CSE/Design & Analysis of Algo.pdf": 101,
	"./CSE/OOP with C++.pdf": 102,
	"./CSE/Operating System.pdf": 103,
	"./CSE/Programming in Python.pdf": 104,
	"./CSE/Programming with C.pdf": 105,
	"./CSE/Theory of Computation.pdf": 106,
	"./ECE/Analog Comm Engineering.pdf": 107,
	"./ECE/Antenna & Wave Propagation.pdf": 108,
	"./ECE/Basic Electronics.pdf": 109,
	"./ECE/Comm & Data Networks.pdf": 110,
	"./ECE/Control Systems.pdf": 111,
	"./ECE/Digital Communication Engineering.pdf": 112,
	"./ECE/Digital Electronics.pdf": 113,
	"./ECE/Digital System Design using Verilog.pdf": 114,
	"./ECE/Electronic Circuits & Simulation.pdf": 115,
	"./ECE/Embedded Systems & Microcontroller.pdf": 116,
	"./ECE/Linear Integrated Circuits & Apps.pdf": 117,
	"./ECE/Microprocessor Systems.pdf": 118,
	"./ECE/Microprocessors & Interfacing.pdf": 119,
	"./ECE/Microwave Engineering.pdf": 120,
	"./ECE/Multimedia Communication.pdf": 121,
	"./ECE/Network Analysis & Synthesis.pdf": 122,
	"./ECE/Signal Processing & Linear System.pdf": 123,
	"./EEE/Basic Electrical.pdf": 124,
	"./EEE/Elec. Measurement and Inst..pdf": 125,
	"./EEE/Electrical Machine-I.pdf": 126,
	"./EEE/Fundamentals of Electrical Engg..pdf": 127,
	"./MAT/Discrete Structures.pdf": 128,
	"./MAT/Engg. Comp. Methods.pdf": 129,
	"./MAT/Engineering Mathematics - I.pdf": 130,
	"./MAT/Engineering Mathematics - II.pdf": 131,
	"./MAT/Integral Transform & Comp Analysis.pdf": 132,
	"./MECH/Dynamics of Machines.pdf": 133,
	"./MECH/Engineering Graphics with CAD.pdf": 134,
	"./MECH/Engineering Mechanics.pdf": 135,
	"./MECH/Fluid Machines.pdf": 136,
	"./MECH/Fluid Mechanics.pdf": 137,
	"./MECH/Kinematics of Machines.pdf": 138,
	"./MECH/Machine Design.pdf": 139,
	"./MECH/Machine Drawing.pdf": 140,
	"./MECH/Manufacturing Processes.pdf": 141,
	"./MECH/Materials Science & Engineering.pdf": 142,
	"./MECH/Mechanics of Materials.pdf": 143,
	"./MECH/Operations Research.pdf": 144,
	"./MECH/Strength of Materials.pdf": 145,
	"./MECH/Thermal Engineering.pdf": 146,
	"./MECH/Thermodynamics.pdf": 147,
	"./MECH/Workshop Practice.pdf": 148,
	"./OTH/Engineering Physics.pdf": 149,
	"./OTH/Entrepreneurship Management.pdf": 150,
	"./OTH/Environmental Studies.pdf": 151,
	"./OTH/Professional Communication.pdf": 152,
	"./PHIL/Constitution of India.pdf": 153,
	"./PHIL/Discourse on Human Virtues.pdf": 154,
	"./PHIL/Intro to Human Rights.pdf": 155,
	"./PHIL/Introduction to Logic.pdf": 156
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.pdf$
// module id = 92
// module chunks = 0